import './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axiosPlugin from './plugins/axios'


loadFonts()

createApp(App).use(store).use(store)
  .use(router)
  .use(store)
.use(axiosPlugin)

    .use(vuetify)
  .mount('#app')
